import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { ISelectOption } from "src/core/constants/options";
import { useLegalStatusListQuery } from "src/core/gql/graphql";

export const useLegalStatusOptions = (): {
  legalStatusOptions: ISelectOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data: legalStatusList, loading, error } = useLegalStatusListQuery();

  const legalStatusOptions: ISelectOption[] = useMemo(() => {
    return (
      legalStatusList?.listElements?.map((legalStatus) => ({
        value: legalStatus.code,
        label: legalStatus.name,
      })) ?? []
    );
  }, [legalStatusList]);

  return { legalStatusOptions, loading, error };
};
